"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withActualizeOffer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("@otpusk/apisearch-toolbox/dist/offers/helpers");
var _selectors = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _actions = require("./store/actions");
var _excluded = ["offerID", "offerTTLAsMinutes", "queryID"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var withActualizeOffer = exports.withActualizeOffer = function withActualizeOffer(Component) {
  var WithActualizeOffer = function WithActualizeOffer(_ref) {
    var mbOfferKey = _ref.offerID,
      offerTTLAsMinutes = _ref.offerTTLAsMinutes,
      queryID = _ref.queryID,
      props = _objectWithoutProperties(_ref, _excluded);
    var dispatch = (0, _reactRedux.useDispatch)();
    var _useMemo = (0, _react.useMemo)(function () {
        return R.map(function (selectorCreator) {
          return R.partialRight(selectorCreator(), [{
            offerID: mbOfferKey
          }]);
        }, [_selectors2.isActualizedOffer, _selectors2.isConnectionFailedWithOperator, _selectors2.isEndActualizedOffer, _selectors2.getActualizedOffer, _selectors2.getMessageByActualizedOffer, _selectors2.getIsStopSaleByHotel]);
      }, [mbOfferKey]),
      _useMemo2 = _slicedToArray(_useMemo, 6),
      isActualizedOfferSelector = _useMemo2[0],
      isConnectionFailedWithOperatorSelector = _useMemo2[1],
      isEndActualizedOfferSelector = _useMemo2[2],
      getActualizedOfferSelector = _useMemo2[3],
      getMessageByActualizedOfferSelector = _useMemo2[4],
      getIsStopSaleByHotelSelector = _useMemo2[5];
    var isActualLastUpdateSelector = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors2.isActualLastUpdate)(), [{
        offerID: mbOfferKey,
        ttlAsMinutes: offerTTLAsMinutes
      }]);
    }, [offerTTLAsMinutes, mbOfferKey]);
    var message = (0, _reactRedux.useSelector)(getMessageByActualizedOfferSelector);
    var isStopSaleByHotel = (0, _reactRedux.useSelector)(getIsStopSaleByHotelSelector);
    var isConnectionFailed = (0, _reactRedux.useSelector)(isConnectionFailedWithOperatorSelector);
    var actualizedOffer = (0, _reactRedux.useSelector)(isStopSaleByHotel ? R.always(null) : getActualizedOfferSelector);
    var isEndActualized = (0, _reactRedux.useSelector)(isEndActualizedOfferSelector);
    var isActualized = (0, _reactRedux.useSelector)(isActualizedOfferSelector);
    var isActualLastOfferUpdate = (0, _reactRedux.useSelector)(isActualLastUpdateSelector);
    var isAlive = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors2.isAliveOffer)(state, {
        offerID: mbOfferKey
      });
    });
    var activeCurrency = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getQueryParam)(state, {
        queryID: queryID,
        paramName: _fn.QUERY_PARAMS.CURRENCY
      });
    });
    var offerID = (0, _helpers.isOfferKey)(mbOfferKey) ? (0, _helpers.extractDataFromOfferKey)(mbOfferKey).id : mbOfferKey;
    (0, _react.useEffect)(function () {
      if (!isActualLastOfferUpdate) {
        dispatch((0, _actions.actualizeOffer)(mbOfferKey, queryID));
      }
    }, [dispatch, isActualLastOfferUpdate, mbOfferKey, queryID]);
    return /*#__PURE__*/_react.default.createElement(Component, _extends({
      actualizedAdditionalPayments: actualizedOffer === null || actualizedOffer === void 0 ? void 0 : actualizedOffer.additionalPayments,
      actualizedIsHeightPromo: actualizedOffer === null || actualizedOffer === void 0 ? void 0 : actualizedOffer.heightPromo,
      actualizedPrice: !isActualized && actualizedOffer ? actualizedOffer.price[activeCurrency] : undefined,
      actualizedPromoText: actualizedOffer ? actualizedOffer.promo || actualizedOffer.heightPromo || undefined : undefined,
      isActualized: isActualized,
      isActualLastUpdate: isActualLastOfferUpdate,
      isAliveOffer: isAlive,
      isConnectionFailedWithOperator: isConnectionFailed,
      isEndActualized: isEndActualized,
      message: message,
      offerID: actualizedOffer ? actualizedOffer.id : offerID,
      offerKey: (0, _helpers.isOfferKey)(mbOfferKey) ? mbOfferKey : undefined,
      queryID: queryID
    }, props));
  };
  WithActualizeOffer.propTypes = {
    offerID: _propTypes.default.string.isRequired,
    offerTTLAsMinutes: _propTypes.default.number,
    queryID: _propTypes.default.string.isRequired
  };
  return WithActualizeOffer;
};